import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UserRegister.css";
import { Box, Checkbox } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PersonIcon from "@mui/icons-material/Person";
import Loading from "../../components/Loading/Loading";
import Modal from "../../components/Modal/Modal";

const API_URL = process.env.REACT_APP_API_URL;

const UserRegister = () => {
	const [formData, setFormData] = useState({
		professor_number: "",
		password: "",
		confirm_password: "",
		is_admin: false,
	});
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const [modalData, setModalData] = useState({
		isVisible: false,
		message: "",
		type: "",
	});

	const handleChange = (event) => {
		setFormData({
			...formData,
			[event.target.name]: event.target.value,
		});
	};

	const handleAdminChange = (event) => {
		const isAdmin = event.target.checked;
		setFormData({
			...formData,
			is_admin: isAdmin,			
			...(!isAdmin && { password: "", confirm_password: "" }),
		});
	};

	const handleRegister = async (event) => {
		event.preventDefault();
		setLoading(true);

		try {			
			const requestData = {
				professor_number: formData.professor_number,
				is_admin: formData.is_admin,
				...(formData.is_admin && {
					password: formData.password,
					confirm_password: formData.confirm_password,
				}),
			};			

			const token = localStorage.getItem("token");
			const response = await fetch(
				`${API_URL}/user-management/register`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Token ${token}`,
					},
					body: JSON.stringify(requestData),
				}
			);

			if (response.ok) {
				setFormData({
					professor_number: "",
					password: "",
					confirm_password: "",
					is_admin: false,
				});
				setModalData({
					isVisible: true,
					message: "کاربر با موقفیت ثبت نام شد",
					type: "success",
				});
				const timer = setTimeout(() => {
					navigate(`/admin/dashboard`);
				}, 2000);
				return () => clearTimeout(timer);
			} else {
				const errorData = await response.json();
				setModalData({
					isVisible: true,
					message: errorData.error,
					type: "error",
				});
			}
		} catch (error) {
			setModalData({
				isVisible: true,
				message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
				type: "error",
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container">
			{loading && <Loading />}
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					px: 2,
					width: "400px",
					margin: "50px 0",
				}}
			>
				<img src="/kntu.ico" alt="khajeh-logo" className="login-logo" />
				<h1 className="login-title">ثبت نام در سیستم</h1>
				<form
					className={`login-form register-form ${
						formData.is_admin ? "expanded" : "collapsed"
					}`}
					onSubmit={handleRegister}
					method="post"
				>
					<div className="login-form-group">
						<label htmlFor="username" className="username-label">
							شناسه استاد
						</label>
						<div className="username-wrapper">
							<input
								className="username-input"
								type="text"
								id="username"
								name="professor_number"
								tabIndex="1"
								value={formData.professor_number}
								onChange={handleChange}
								required
							/>
							<button type="button" className="username-icon">
								<PersonIcon fontSize="large" />
							</button>
						</div>
					</div>
					
					{formData.is_admin && (
						<>
							<div className="form-group">
								<label
									htmlFor="password"
									className="password-label"
								>
									رمز عبور
								</label>
								<div className="password-wrapper">
									<input
										className="password-input"
										type={
											showPassword ? "text" : "password"
										}
										id="password"
										name="password"
										tabIndex="2"
										value={formData.password}
										onChange={handleChange}
										required={formData.is_admin}
									/>
									<button
										type="button"
										className="toggle-password"
										onClick={() =>
											setShowPassword(!showPassword)
										}
									>
										{showPassword ? (
											<Visibility fontSize="large" />
										) : (
											<VisibilityOff fontSize="large" />
										)}
									</button>
								</div>
							</div>
							<div className="form-group">
								<label
									htmlFor="confirm_password"
									className="password-label"
								>
									تایید رمز عبور
								</label>
								<div className="password-wrapper">
									<input
										className="password-input"
										type={
											showConfirmPassword
												? "text"
												: "password"
										}
										id="confirm_password"
										name="confirm_password"
										tabIndex="3"
										value={formData.confirm_password}
										onChange={handleChange}
										required={formData.is_admin}
									/>
									<button
										type="button"
										className="toggle-password"
										onClick={() =>
											setShowConfirmPassword(
												!showConfirmPassword
											)
										}
									>
										{showConfirmPassword ? (
											<Visibility fontSize="large" />
										) : (
											<VisibilityOff fontSize="large" />
										)}
									</button>
								</div>
							</div>
						</>
					)}

					<div className="is-admin-checkbox">
						<Checkbox
							size="large"
							checked={formData.is_admin}
							onChange={handleAdminChange}
						/>
						ادمین
					</div>

					<button
						className="login-button medium-text"
						type="submit"
						tabIndex="4"
					>
						ثبت
					</button>
				</form>
				<Modal
					message={modalData.message}
					type={modalData.type}
					isVisible={modalData.isVisible}
					onClose={() =>
						setModalData({ ...modalData, isVisible: false })
					}
				/>
			</Box>
		</div>
	);
};

export default UserRegister;
